<template>
  <lm-alert v-show="show" :type="type" :msg="msg" @close="show = false" />
</template>

<script>
import LmAlert from '@/components/ui/LmAlert'
import EventHub from '@/lib/eventHub'
import {Events, Alert as AlertType} from '@/lib/definitions'

export default {
  name: 'MainAlert',
  components: {LmAlert},
  data() {
    return {
      AlertType,
      show: false,
      type: AlertType.ERROR,
      msg: 'Generic error',
      duration: 6000,
      timeout: null
    }
  },
  mounted() {
    EventHub.on(
      Events.SHOW_ALERT,
      (msg, type = AlertType.ERROR, autoClose = true) => {
        this.msg = msg
        this.type = type
        this.show = true
        this.resetTimeout()
        if (autoClose) {
          this.timeout = setTimeout(() => this.close(), this.duration)
        }
      }
    )
  },
  methods: {
    close() {
      this.resetTimeout()
      this.show = false
    },
    resetTimeout() {
      if (this.timeout) clearTimeout(this.timeout)
    }
  }
}
</script>
